import React, { Component } from 'react';
import './Index.css';

class Index extends Component {

  // TODO: there's some really stupid stuff going on here

  render() {
    return (
      <div className='Index'>
        <div className='Index-inner'>
          <span className='Index-list'>
            <p className='Index-project paragraph font-white font-bold' onClick={(e) => {
              this.props.changePage(e, "home")
              window.scrollTo(0, 0);
            }}>Home</p>
            <p className='Index-spacer paragraph'>&nbsp;</p>
            <p className='Index-spacer paragraph'>&nbsp;</p>
            <p className='Index-spacer paragraph'>&nbsp;</p>
            <p className='Index-spacer paragraph'>&nbsp;</p>
          </span>

          <span className='Index-list'>
            <p className='Index-project paragraph font-white font-bold' onClick={(e) => {
              this.props.changePage(e, "home-portfolio");
            }}
            >Portfolio</p>
            <p className='Index-project paragraph font-white' onClick={(e) => {
              this.props.changePage(e, "portfolio");
              this.props.changeProject(e, "rebirth");
              window.scrollTo(0, 0);
            }}>Rebirth</p>
            <p className='Index-project paragraph font-white' onClick={(e) => {
              this.props.changePage(e, "portfolio");
              this.props.changeProject(e, "in_a_week");
              window.scrollTo(0, 0);
            }}>In A Week</p>
            <p className='Index-project paragraph font-white' onClick={(e) => {
              this.props.changePage(e, "portfolio");
              this.props.changeProject(e, "night_flight");
              window.scrollTo(0, 0);
            }}>Night Flight</p>
            <p className='Index-project paragraph font-white' onClick={(e) => {
              this.props.changePage(e, "portfolio");
              this.props.changeProject(e, "trend_2020");
              window.scrollTo(0, 0);
            }}>Trend Portfolio 2020</p>
          </span>

          <span className='Index-list'>
            <p className='Index-project paragraph font-white font-bold' onClick={(e) => {
              this.props.changePage(e, "about");
            }}>About</p>
            <p className='Index-spacer paragraph'>&nbsp;</p>
            <p className='Index-spacer paragraph'>&nbsp;</p>
            <p className='Index-spacer paragraph'>&nbsp;</p>
            <p className='Index-spacer paragraph'>&nbsp;</p>
          </span>

          <span className='Index-list'>
            <p className='Index-project paragraph font-white font-bold' onClick={(e) => {
              this.props.changePage(e, "press");
              window.scrollTo(0, 0);
            }}>Press</p>
            <p className='Index-spacer paragraph'>&nbsp;</p>
            <p className='Index-spacer paragraph'>&nbsp;</p>
            <p className='Index-spacer paragraph'>&nbsp;</p>
            <p className='Index-spacer paragraph'>&nbsp;</p>
          </span>


          <span className='Index-list'>
            <p className='Index-project paragraph font-white font-bold' onClick={(e) => {
              this.props.changePage(e, "contact");
              window.scrollTo(0, 0);
            }}>Contact</p>
            <p className='Index-project paragraph font-white' onClick={(e) => {
              window.open("https://www.instagram.com/beth.knit/", '_blank');
            }}>Instagram</p>
            <p className='Index-project paragraph font-white' onClick={(e) => {
              window.open("https://twitter.com/beth_knit", '_blank');
            }}>Twitter</p>
            <p className='Index-project paragraph font-white' onClick={(e) => {
              window.open("https://www.linkedin.com/in/beth-simmons-56b905153/", '_blank');
            }}>LinkedIn</p>
            <p className='Index-spacer paragraph'>&nbsp;</p>
          </span>
        </div>

        <div className='Index-footer'>
          <hr className='Index-hr' />
          <p className='Index-footer-p paragraph font-grey'>©2019, 2020 Beth Simmons. All rights reserved.<br/>Website by Matt Simmons.</p>
        </div>
      </div>
    );
  }
}



export default Index;
